module.exports = __webpack_public_path__ + "img/pic_number_70_black.b3528fa0.png";